module.exports = __webpack_public_path__ + "img/join-cart.ea0ddb9b.png";